import React from 'react';
import Marquee from 'react-fast-marquee';
import Box from '@mui/material/Box';
import Image from 'next/image';
import { API } from '_helpers';

interface Props {
  data: CPartners;
}

const Partner: React.FC<Props> = ({ data }) => {
  return (
    <Marquee speed={50} gradient={true} gradientColor={[0, 15, 33]}>
      {data?.list?.map((el, i) => (
        <Box
          sx={{
            width: 200,
            height: 100,
            mx: { xs: 2, sm: 4, md: 6 },
            position: 'relative',
          }}
          key={i}
        >
          <Image
            src={`${API}${el?.media?.url}`}
            alt={el?.media?.alternativeText}
            title="partner"
            layout="fill"
            objectFit="contain"
          />
        </Box>
      ))}
    </Marquee>
  );
};

export default Partner;
